export default "__VITE_ASSET__0f2eac6b__"